/**
 * チュートリアルミッションの案内で使う DOM の小道具 (ブラウザ専用)。
 */

/** セレクタに当たる要素のうち、画面に出ている最初のもの (閉じたメニューの中身などは除く) */
export function findVisibleElement(selector: string): HTMLElement | null {
  let list: NodeListOf<HTMLElement>;
  try {
    list = document.querySelectorAll<HTMLElement>(selector);
  } catch {
    return null;
  }
  for (const el of Array.from(list)) {
    if (el.getClientRects().length === 0) continue;
    if (window.getComputedStyle(el).visibility === "hidden") continue;
    return el;
  }
  return null;
}

export function isElementVisible(selector: string): boolean {
  return findVisibleElement(selector) !== null;
}

/** お祝いを重ねないための目印 (TutorialClearModal の wrapClassName) */
export const TUTORIAL_CLEAR_MODAL_CLASS = "gc-tutorial-clear";

/**
 * ほかのモーダル (ガチャの結果・ミッションクリア・レベルアップ等) や使い方ツアーが開いているか。
 * 開いている間はチュートリアルのお祝いを出さずに待つ。
 */
export function isOtherOverlayOpen(): boolean {
  const overlays = document.querySelectorAll<HTMLElement>(".ant-modal-wrap, .ant-tour");
  return Array.from(overlays).some(
    (el) =>
      !el.closest(`.${TUTORIAL_CLEAR_MODAL_CLASS}`) &&
      el.getClientRects().length > 0 &&
      window.getComputedStyle(el).display !== "none",
  );
}

/** チュートリアルミッションの「ミッションクリア！」が出ているか (使い方ツアーはこの間、開くのを待つ) */
export function isTutorialCelebrationOpen(): boolean {
  const wraps = document.querySelectorAll<HTMLElement>(
    `.ant-modal-wrap.${TUTORIAL_CLEAR_MODAL_CLASS}`,
  );
  return Array.from(wraps).some(
    (el) => el.getClientRects().length > 0 && window.getComputedStyle(el).display !== "none",
  );
}

/** 使い方ツアーが開いているか (開いている間は画面下の案内を隠す) */
export function isTourOpen(): boolean {
  const tours = document.querySelectorAll<HTMLElement>(".ant-tour");
  return Array.from(tours).some((el) => el.getClientRects().length > 0);
}

/** ホーム画面に追加したアイコンから開いているか (iPhone の Safari は navigator.standalone) */
export function isStandaloneDisplay(): boolean {
  try {
    if (window.matchMedia("(display-mode: standalone)").matches) return true;
    if (window.matchMedia("(display-mode: fullscreen)").matches) return true;
    return (navigator as Navigator & { standalone?: boolean }).standalone === true;
  } catch {
    return false;
  }
}
